// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { routes } from '@seedplanner/shared-web';
import { createApolloClient } from './createApolloClient';
import { createAppContext } from './createAppContext';
import { renderApp } from './renderApp';
import { sendErrorReport } from './sendErrorReport';

export const render = () => {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  const currentWindow = window as any;

  const apolloClient = createApolloClient({
    endpoint: routes.GRAPHQL,
    apolloState: currentWindow.__APOLLO_STATE__,
  });
  const appContext = createAppContext({
    environment: currentWindow.__ENV__,
    css: currentWindow.__CSS__,
    nonce: currentWindow.__NONCE__,
    options: currentWindow.__OPTIONS__,
    userAgent: currentWindow.__USER_AGENT__,
    enableSubscriptionEnforcement: currentWindow.__ENABLE_SUBSCRIPTION_ENFORCEMENT__,
  });
  const initialLocalState = currentWindow.__INITIAL_LOGGED_IN_STATE__;
  const intitialUserState = currentWindow.__INITIAL_USER_STATE__;

  if (initialLocalState == null) {
    sendErrorReport({
      body: {
        errorMessage: 'initialLoggedInState is null!',
        location: window.location.pathname,
      },
      labels: {},
      endpoint: routes.ERROR,
    });
  }

  renderApp(appContext, apolloClient, initialLocalState, intitialUserState);
};
